import { useMissionsTranslation } from '../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { usePermission } from '@juvare/contact-management/ui/hooks';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useSearchParams } from 'react-router';
import { TimeTrackingHeader } from './components/TimeTrackingHeader';
import { TimeTrackingTable } from './components/TimeTrackingTable';
import { VolunteerHours } from './components/VolunteerHours';
import { useTimeTrackingAnalytics } from './hooks/useTimeTrackingAnalytics';
export const TimeTrackingPage = () => {
    var _a, _b, _c;
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useMissionsTranslation();
    const { requireAnySystemPermission } = usePermission();
    const { timeTrackingAnalytics } = useTimeTrackingAnalytics();
    const defaultTab = 'myhours';
    const activeTab = searchParams.get('tab') || defaultTab;
    return (React.createElement(Box, { display: 'flex', flexDirection: 'column' },
        React.createElement(TimeTrackingHeader, { approvedMissions: (_a = timeTrackingAnalytics === null || timeTrackingAnalytics === void 0 ? void 0 : timeTrackingAnalytics.approvedMissions) !== null && _a !== void 0 ? _a : 0, approvedShifts: (_b = timeTrackingAnalytics === null || timeTrackingAnalytics === void 0 ? void 0 : timeTrackingAnalytics.approvedShifts) !== null && _b !== void 0 ? _b : 0, approvedHours: (_c = timeTrackingAnalytics === null || timeTrackingAnalytics === void 0 ? void 0 : timeTrackingAnalytics.approvedHours) !== null && _c !== void 0 ? _c : 0 }),
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                px: 4,
                borderBottom: 1,
                borderColor: themeColors.border.main,
                boxShadow: 1,
                zIndex: 1,
            } },
            React.createElement(Tabs, { variant: 'scrollable', value: activeTab, onChange: (event, value) => {
                    setSearchParams((prevValues) => {
                        prevValues.set('tab', value);
                        return prevValues;
                    }, { replace: true });
                } },
                React.createElement(Tab, { label: t('timeTracking.tabs.myHours'), value: 'myhours', "data-test": 'my-hours-tab' }),
                requireAnySystemPermission('manage-time-tracking') && (React.createElement(Tab, { label: t('timeTracking.tabs.volunteerHours'), value: 'volunteerHours', "data-test": 'volunteer-hours-tab' })))),
        React.createElement(Box, { sx: { px: 4, backgroundColor: themeColors.background } },
            React.createElement(Box, { pt: 3, display: 'flex', flexDirection: 'column', gap: 1 },
                activeTab === 'myhours' && React.createElement(TimeTrackingTable, null),
                activeTab === 'volunteerHours' && React.createElement(VolunteerHours, null)))));
};
